
<img class="wep-image__image"
     [attr.class]="css"     
     [src]="getSrc()"
     [alt]="alt"
     (load)="loaded()"
     (error)="reloadSrc($event)">
